import React from 'react';

/**
 * Props  : [{ key, name, size, qty }]
 * Design : light card, sticky header, subtle shadow,
 *          quantity badge scales with number (2-digit = wider),
 *          hover & badge now use blue instead of indigo
 */
export default function ItemBoard({ items }) {
  return (
    <aside
      className="sidebar w-72 shrink-0 bg-white/90 backdrop-blur-sm
                 rounded-2xl shadow-xl flex flex-col ring-1 ring-black/5"
    >
      {/* ── header ── */}
      <header className="sticky top-0 z-10 px-4 py-3 border-b bg-white/80 backdrop-blur-md">
        <h2 className="font-semibold text-lg tracking-tight">Items Board</h2>
      </header>

      {/* ── list ── */}
      <div
        className="flex-1 overflow-y-auto
                   scrollbar-thin scrollbar-thumb-[#c7c9e0]/60
                   scrollbar-track-transparent"
      >
        {items.length === 0 && (
          <p className="py-10 text-center text-gray-400">No data</p>
        )}

        {items.map(it => (
          <div
            key={it.key}
            className="group flex items-center justify-between gap-2
                       px-4 py-3 border-b last:border-b-0
                       hover:bg-blue-50/30 transition-colors"
          >
            {/* name + optional size */}
            <div className="min-w-0">
              <p className="font-medium truncate">{it.name}</p>
              {it.size && (
                <p className="text-xs text-gray-500 truncate">
                  Size: {it.size}
                </p>
              )}
            </div>

            {/* qty badge – width grows if number ≥ 100 */}
            <span
              className="flex items-center justify-center rounded-full
                         bg-blue-600 text-white text-[11px] font-semibold
                         min-w-[1.5rem] h-[1.5rem] px-[0.25rem]"
            >
              {it.qty}
            </span>
          </div>
        ))}
      </div>
    </aside>
  );
}
